import * as constants from './constants'

const acceptedCookies = localStorage.getItem('acceptedCookies')
const cookiesInitialState = {
    cookiesAccepted: acceptedCookies ? JSON.parse(acceptedCookies) : null,
    cookiesModalOpen: false,
}

export const reducer = (state = cookiesInitialState, action) => {
    switch (action.type) {
        case constants.SET_COOKIES:
            localStorage.setItem('acceptedCookies', action.data ? JSON.stringify(action.data) : false)
            return {
                ...state,
                cookiesAccepted: action.data,
                cookiesModalOpen: false,
            }
        case constants.OPEN_COOKIES_MODAL:
            return {
                ...state,
                cookiesModalOpen: true,
            }
        default:
            return state
    }
}
